import React from "react";
import { Carousel } from "antd";
import { Link } from "react-router-dom";
import "./BannerCarousel.css";
import AnimatedElement from "./AnimatedElement";
import { useTranslation } from "react-i18next";

const BannerCarousel = () => {
  const { t } = useTranslation();

  const banners = [
    {
      title: "",
      subtitle: t("banner1.subtitle"),
      description: t("banner1.description"),
      image: "/assets/img/banners/IA2.jpg",
      buttonText: t("banner1.buttonText"),
      buttonLink: "/solicitar-reuniao",
    },
    {
      title: "",
      subtitle: t("banner2.subtitle"),
      description: t("banner2.description"),
      image: "/assets/img/banners/CSAP.jpg",
      buttonText: t("banner2.buttonText"),
      buttonLink: "/cuidados-saude-atencao-primaria",
    },
    {
      title: "",
      subtitle: t("banner3.subtitle"),
      description: t("banner3.description"),
      image: "/assets/img/banners/RHA3.jpg",
      buttonText: t("banner3.buttonText"),
      buttonLink: "/reproducao-humana-assistida",
    },
  ];

  return (
    <Carousel autoplay effect="fade" className="banner-carousel">
      {banners.map((banner, idx) => (
        <div key={idx} className="banner-slide">
          <div
            className="banner-bg"
            style={{ backgroundImage: `url(${banner.image})` }}
          >
            <div className="banner-overlay">
              <div className="banner-content">
                <div className="banner-text">
                  <AnimatedElement animation="fade-up" delay={200}>
                    <h1 className="banner-title">{banner.title}</h1>
                  </AnimatedElement>
                  <AnimatedElement animation="fade-up" delay={400}>
                    <h2 className="banner-subtitle">{banner.subtitle}</h2>
                  </AnimatedElement>
                  <AnimatedElement animation="fade-up" delay={600}>
                    <p className="banner-description">{banner.description}</p>
                  </AnimatedElement>
                  <AnimatedElement animation="fade-up" delay={800}>
                    <Link to={banner.buttonLink} className="banner-cta-button">
                      {banner.buttonText}
                    </Link>
                  </AnimatedElement>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </Carousel>
  );
};

export default BannerCarousel;
